import { pageContainerStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPageContainer";
import { checkoutReviewAndSubmitPaymentDetailsStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { shippingInfoStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import { paymentProfileBillingAddressStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PaymentProfileBillingAddress";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

pageContainerStyles.actionButtonsBottomGridItem = {
    css: css`
        order: 4;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        // display: none;
                    `,
                    null,
                    null,
                    null,
                    null,
                ],
                "max",
            )}
    `,
    width: 12,
};

shippingInfoStyles.shippingInfoAccordionSection = {
    titleTypographyProps: { weight: 600 },
    headerProps: {
        css: css`
            background: #ffffff;
            button {
                &:focus {
                    border: 1px solid #cccccc;
                }
            }
        `,
    },
};

promotionCodeFormStyles.applyButton = {
    variant: "tertiary",
    css: css`
        margin-top: 2rem;
        span {
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 2px;
            line-height: normal;
            text-align: center;
            color: #ffffff;
            text-transform: uppercase;
        }
    `,
};

checkoutReviewAndSubmitPaymentDetailsStyles.creditCardAddress = {
    container: {
        gap: 10,
        css: css`
            display: none;
        `,
    },
};

paymentProfileBillingAddressStyles.wrapper = {
    css: css`
        display: none;
    `,
};
